import { IConfigurableFieldValueResponse } from '@shared/interfaces';

export const getListValueFromReference = (
  reference: IConfigurableFieldValueResponse[],
  type: string
) => {
  return (
    reference
      ?.find(
        (ref) => ref?.field?.name?.toUpperCase()?.trim() === type.toUpperCase()
      )
      ?.value?.toString() || ''
  );
};
